export enum UserAccessRole {
    BRAND = 'BRAND',
    BRANCH = 'BRANCH',
    CORPORATE = 'CORPORATE',
    INDIVIDUAL = 'INDIVIDUAL'
}